import {
	PanelBody,
	SelectControl,
	RangeControl,
	TextControl,
	ToggleControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const TYPE_OPTIONS = [
	{ label: __( 'Number Counter', 'brandy-blocks' ), value: 'number' },
	{ label: __( 'Circle Progress', 'brandy-blocks' ), value: 'circle' },
];

export default function CounterSettings( { attributes, setAttributes } ) {
	const isManual = ( attributes.source || 'manual' ) === 'manual';

	return (
		<PanelBody title={ __( 'Counter Settings', 'brandy-blocks' ) }>
			<SelectControl
				__nextHasNoMarginBottom
				__next40pxDefaultSize
				label={ __( 'Type', 'brandy-blocks' ) }
				value={ attributes.type }
				options={ TYPE_OPTIONS }
				onChange={ ( v ) => setAttributes( { type: v } ) }
			/>
			{ isManual && (
				<>
					<RangeControl
						__nextHasNoMarginBottom
						label={ __( 'Start value', 'brandy-blocks' ) }
						value={ attributes.startValue }
						onChange={ ( v ) => setAttributes( { startValue: v } ) }
						min={ 0 }
						max={ 99999 }
					/>
					<RangeControl
						__nextHasNoMarginBottom
						label={ __( 'End value', 'brandy-blocks' ) }
						value={ attributes.endValue }
						onChange={ ( v ) => setAttributes( { endValue: v } ) }
						min={ 0 }
						max={ 99999 }
					/>
				</>
			) }
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Duration (ms)', 'brandy-blocks' ) }
				value={ attributes.duration }
				onChange={ ( v ) => setAttributes( { duration: v } ) }
				min={ 500 }
				max={ 10000 }
				step={ 100 }
			/>
			<TextControl
				__nextHasNoMarginBottom
				label={ __( 'Prefix', 'brandy-blocks' ) }
				value={ attributes.prefix }
				onChange={ ( v ) => setAttributes( { prefix: v } ) }
			/>
			<TextControl
				__nextHasNoMarginBottom
				label={ __( 'Suffix', 'brandy-blocks' ) }
				value={ attributes.suffix }
				onChange={ ( v ) => setAttributes( { suffix: v } ) }
			/>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Thousand separator', 'brandy-blocks' ) }
				checked={ attributes.useThousandSeparator }
				onChange={ ( v ) =>
					setAttributes( { useThousandSeparator: v } )
				}
			/>
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Decimal places', 'brandy-blocks' ) }
				value={ attributes.decimals }
				onChange={ ( v ) => setAttributes( { decimals: v } ) }
				min={ 0 }
				max={ 4 }
			/>
		</PanelBody>
	);
}
